import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch"
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import './Analist.css';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const AnalistEdit =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {	

		constructor(props){
			super(props);
			this.state = {
				analista: {
					nome: "",
					email: "",
					orgao: "",
					api: "",
				},
				orgaos: [],
				apis: [],
				edicao : false,
				botoesHabilitados : true,
				carregandoOrgaos: false,
				carregandoApis: false,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.carregaApis = this.carregaApis.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>{ this.state.edicao ? "Alteração de Analistas responsáveis pelos sistemas consumidores das APIs do Órgão" : "Cadastro de Analistas responsáveis pelos sistemas consumidores das APIs do Órgão" }</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			if(id){
				this.setState({edicao : true}) 
				api.get('/api/analista/' + id)
				.then(response => { 
					const analista = response.data;
					
					this.setState(
						{
							analista,
						}) 
					//this.carregaFornecedorasOrgao(gestor.orgao);
				})
				.catch(erro => {
					console.log("Não foi possível recuperar o analista " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			}else{
				this.setState({edicao : false,}) 
			}

			this.setState({carregandoOrgaos : true});
			api.get('/api/orgao/perfil-usuario?ativos=true')
				.then(response => { 
					this.setState({
						orgaos: response.data,
						carregandoOrgaos: false
					})
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os órgãos " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});

		}

		renderForm() {
			const analista = this.state.analista;

			return(
				<div className="container-fluid">
					<div className="br-form">

					{ (this.state.edicao === false) && 
						<div className="row">

								<div className="col-md-6">
									<div className="field">
										<div className="input">
											<label htmlFor="orgao">Órgão:</label>						
										</div>
										<div className="input">
											{this.state.carregandoOrgaos === false &&
												<SelectSearch
													id="orgao"
													name="orgao"
													options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
													onChange={this.handleOrgaoChange}
													value={analista.orgao}	

												/>
											}
											{this.state.carregandoOrgaos === true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>	

							{(analista.orgao) &&	
								<div className="col-md-6">
									<div className="field">
										<div className="input">
											<label htmlFor="api">API:</label>
											{this.state.carregandoApis === false &&
											<SelectSearch
												id="api"
												name="api"
												options={this.state.apis.map(api => ({ id: api.id, nome: api.nome }))}
												onChange={values => this.handleMultiSelectChange('api', values)}
												value={analista.api}
												placeholder="Nenhuma API selecionada"
												noOptionsMessage="Nenhuma API encontrada"
												optionName="nome"
												optionValue="id"
											/>
										}
											{this.state.carregandoApis=== true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
										</div>
									</div>
								</div>
							}
						</div>
		}	

						{ (this.state.edicao === true) && 
						
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="orgao">Orgão:</label>						
											<input type="text" name="orgao" 
												value={this.state.analista.nomeOrgao}  
												readOnly
												disabled/>
										</div>
									</div>
								</div>

								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="api">API:</label>						
											<input type="text" name="api" 
												value={this.state.analista.nomeApi}  
												readOnly
												disabled/>
										</div>
									</div>
								</div>
						</div>
						}
							
						<div className="row">
							<div className="col">
								<div className="field">
									<div className="input">
										<label htmlFor="nome">Nome (Informar o nome do Analista ou da Área):</label>						
										<input type="text" name="nome" 
													value={this.state.analista.nome}  
													onChange={this.handleInputChange} 
													maxLength="100"/>
									</div>
								</div>
							</div>
						
						
					
							<div className="col">
								<div className="field">
									<div className="input">
										<label htmlFor="email">E-mail (Informar o e-mail do Analista ou da Área):</label>	
										<input type="text" name="email" 
												value={this.state.analista.email}  
												onChange={this.handleInputChange} 
												maxLength="100"/>	
									</div>
								</div>
							</div>
						</div>

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{analista.orgao &&
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>{this.state.edicao ? 'Alterar' : 'Incluir'}</button>
								}

								{this.state.edicao && 
									<button type="button" className="button is-secondary" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Novo</button>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			const analista = this.state.analista;
			analista[nome] = valor;
			this.setState({ analista });
		}

		handleOrgaoChange(evento){
			const idOrgao = evento.target.value;
			const analista = this.state.analista;
			analista['orgao'] = idOrgao;
			analista['api'] = "";
	
			this.setState({ 
				analista,
			});

			this.carregaApis(idOrgao);
		}


		carregaApis(idOrgao){
			if(idOrgao && idOrgao !== ""){
				this.setState({carregandoApis : true});
				api.get(`/api/orgao/${idOrgao}/fornecedoras`)
				.then(response => { 
					this.setState(
						{
							apis: response.data,
							carregandoApis : false
						}
					);
				})
				.catch(erro => {
					this.setState({carregandoApis : false});
					console.log("Não foi possível recuperar as aplicações apis associadas ao órgão " + JSON.stringify(erro));
					this.props.exibeMensagemErro("Erro durante o carregamento das API's do órgão.")
				});
			}
		}


		handleMultiSelectChange(propriedade, values){
			const valoresSelecionados = values.target.value;
			const analista = this.state.analista;
			analista[propriedade] = valoresSelecionados;
			this.setState(
				{ 
					analista,
				});
		}

		novo(e){
			if (this.props.location.pathname === "/analist/new") {
				this.setState({
					analista: {
						nome: "",
						email: "",
						orgao: "",
						api: "",
					},
					apis: [],
					edicao: false,
				});
				this.props.limpaMensagem();
			} else {
				this.props.history.push("/analist/new");
			}
		}

		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState({botoesHabilitados:false});
			const analista = this.state.analista;
			const method = this.state.edicao ? 'put' : 'post';
			let url = "/api/analista";

			const options = {
				method,
				url,
				"data" : analista,
			}

			api(options)
				.then(response => {
					const mensagem = `Analista ${this.state.edicao ? 'alterado' : 'incluído'} com sucesso!`;
					this.setState({ 
						analista: response.data,
						edicao: true,
					});
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.edicao ? 'alterar' : 'incluir'} o analista.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
				});   

		}

		validaFormulario(){
			let mensagens;

			mensagens = this.validaAnalista();
			

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		validaAnalista(){
			let mensagens = [];

			const orgao = this.state.analista.orgao;
			this.adicionaMensagemSeCampoNaoPreenchido(orgao, mensagens, "Órgão");

			const api = this.state.analista.api;
			this.adicionaMensagemSeCampoNaoPreenchido(api, mensagens, "API");

			const nome = this.state.analista.nome;
			this.adicionaMensagemSeCampoNaoPreenchido(nome, mensagens, "Nome");

			const email = this.state.analista.email;
			this.adicionaMensagemSeCampoNaoPreenchido(email, mensagens, "Email");

			return mensagens;
		}

		adicionaMensagemSeCampoNaoPreenchido(valorPropriedade, mensagens, campoFormulario){
			if(!valorPropriedade || (typeof (valorPropriedade) == 'string' && valorPropriedade.trim().length === 0 )){
				mensagens.push({'mensagem' : campoFormulario + ' obrigatório.'})
			}
		}

	}

) // redux
); // router